import { DixaSDK, useDixa } from '@devsbb/dixa-sdk';
import { redirectToHelpCenter } from 'ggApp/utils/helpCenterURL';
import { DIXA } from 'ggApp/modules/featureFlag/constants';
import { useFeatureFlags } from 'ggApp/modules/featureFlag';

function useDixaWithHelpCenter(activeLanguage: string): DixaSDK {
    const { isFlagEnabled, getFeatureFlag } = useFeatureFlags();
    const dixaSDK = useDixa();

    const flag = getFeatureFlag(DIXA);
    const show =
        flag?.flagID && isFlagEnabled(DIXA)
            ? dixaSDK.show
            : () => redirectToHelpCenter(activeLanguage);

    return {
        ...dixaSDK,
        show,
    };
}

export { useDixaWithHelpCenter as useDixa };
